import {TREE_COMPONENTS} from "./tree";
import { BusinessCategoryContainerComponent} from "./categories-agregator";
import {SelectableListComponent} from "./list/selectable-list.component";

export const BUSINESS_TYPE_CATEGORIES = [
    ...TREE_COMPONENTS,
    SelectableListComponent,
    BusinessCategoryContainerComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/index.ts